import React, { useState, useEffect } from 'react';
import getRecsSessionValue from '@tvg/recs-get-session';
import useEsiPortal from '../../hooks/useEsiPortal';
import styles from './Recommendations.module.css';

type Props = {
  hideBorder?: boolean;
};

function Recommendations(props: Props) {
  const { hideBorder = false } = props;
  const [esiLoaded, setEsiLoaded] = useState(false);
  const ref = useEsiPortal('esi-recommendations');

  useEffect(() => {
    const interval = setInterval(() => {
      const divExists = document.querySelector('[data-testid="recommendations-carousel"]') !== null;
      if (divExists) {
        getRecsSessionValue();
        setEsiLoaded(true);
        clearInterval(interval);
      }
    }, 500);

    const timeout = setTimeout(() => {
      clearInterval(interval);
    }, 15000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [esiLoaded]);

  return (
    <div>
      {esiLoaded && hideBorder && <div className={styles.divider} data-testid="recs-divider" />}
      {esiLoaded && !hideBorder && <div className={styles.borderDivider} data-testid="recs-border-divider" />}
      <div ref={ref} />
    </div>
  );
}

export default Recommendations;
